import { render } from "./FormNumber.vue?vue&type=template&id=3a3b56e5"
import script from "./FormNumber.vue?vue&type=script&lang=js"
export * from "./FormNumber.vue?vue&type=script&lang=js"
script.render = render

export default script